const styles = theme => ({
  bedsAvailabilityRoot: {
    display: 'grid',
    gridTemplateRows: '60px 3fr 60px',
    gridTemplateColumns: '4fr 300px 4fr',
  },
  title: {
    paddingTop: 20,
    paddingLeft: 15,
    fontSize: '1.0rem',
  },
  chartWrapper: {
    minWidth: 350,
    maxWidth: 350,
    gridRow: '2 / 3',
    gridColumn: '2 / 3',
  },
  freeBedsCount: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gridRow: '2 / 3',
    gridColumn: '3 / 3',
    textAlign: 'center',
  },

  allBedsCount: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gridRow: '2 / 3',
    gridColumn: '0 / 3',
    textAlign: 'center',
  },
  allBedsCountNumber: {
    color: '#333333',
  },
  overBedsCountNumber: {
    color: '#FF3333',
  },
  freeBedsCountNumber: {
    color: '#029AB1',
  },

  footer: {
    gridRow: '3 / 3',
    gridColumn: '1 / 4',
  },
});

export default styles;